var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recaptcha"},[_c('div',{staticClass:"recaptcha__widget",attrs:{"id":"g-recaptcha","data-sitekey":_vm.sitekey}}),(_vm.errors && _vm.errors.length)?_c('div',{staticClass:"recaptcha__errors"},_vm._l((_vm.errors),function(err,i){return _c('span',{key:i,staticClass:"recaptcha__errors-item"},[_vm._v(_vm._s(err))])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }